import type { RootState } from 'store'

export const getPath = (state: RootState) => {
  return state.pages.path
}

export const getBreadcrumbs = (state: RootState) => {
  return state.pages.breadcrumbs
}

export const getCommentTopics = (state: RootState) => {
  return state.pages.commentTopics
}

export const getComponents = (state: RootState) => {
  return state.pages.components
}

export const getSidebarComponents = (state: RootState) => {
  return state.pages.sidebarComponents
}

export const getContentType = (state: RootState) => {
  return state.pages.contentType
}

export const getTitle = (state: RootState) => {
  return state.pages.title
}

export const getSocialMetaData = (state: RootState) => {
  return state.pages.socialMetaData
}

export const getContentPublishDate = (state: RootState) => {
  return state.pages.contentPublishDate
}
